if (!customElements.get('payment-view-modal')) {
    customElements.define('payment-view-modal', class QuickAddModal extends ModalDialog {
        constructor() {
            super();
        }

        hide(preventFocus = false) {
            super.hide();
        }

        show(opener) {
            console.log(this.dataset.key)
            console.log(this.dataset.url)
            if (this.dataset.url) {
                opener.setAttribute('aria-disabled', true);
                opener.classList.add('loading');
                opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

                // this.querySelector("iframe.target").setAttribute("src" , this.dataset.url);
                // super.show(opener);
                // opener.removeAttribute('aria-disabled');
                // opener.classList.remove('loading');
                // opener.querySelector('.loading-overlay__spinner').classList.add('hidden');

                fetch(this.dataset.url)
                    .then((response) => response.text())
                    .then((responseText) => {

                        let keyDiv = new DOMParser()
                            .parseFromString(responseText, 'text/html')
                            .querySelector('#' + this.dataset.key);

                        console.log(keyDiv)
                        if (keyDiv) {
                            this.querySelector("#modal-holder").innerHTML = keyDiv.outerHTML;
                            super.show(opener);
                        }

                    })
                    .finally(() => {
                        opener.removeAttribute('aria-disabled');
                        opener.classList.remove('loading');
                        opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
                    });
            }
        }
    });
}
